import { useAppUpdateStore } from '@/hooks/use-update-app.ts'
import { registerServiceWorker } from './register-service-worker'

// Any built mode has sw.js (production, and e2e for apps/e2e); dev-sw.js is the dev server's
const swUrl = `/${import.meta.env.PROD ? 'sw.js' : 'dev-sw.js?dev-sw'}`

export const initServiceWorker = () =>
  registerServiceWorker({
    url: swUrl,
    onUpdateFound: () => {
      useAppUpdateStore.setState({ hadUpdateAt: new Date() })
    },
    updatePollingIntervalSeconds: 60 * 2, // 2 minutes
  })
